"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLoanApplication = createLoanApplication;
exports.getLoanApplication = getLoanApplication;
exports.getOrCreateDraftLoan = getOrCreateDraftLoan;
exports.getUserDraftLoan = getUserDraftLoan;
exports.getUserLoanApplications = getUserLoanApplications;
exports.submitLoanApplication = submitLoanApplication;
exports.updateLoanApplication = updateLoanApplication;
var firestore_1 = require("firebase/firestore");
var lead_source_1 = require("../../../constants/lead_source");
var loan_application_1 = require("../../../types/loan-application");
var firebase_1 = require("../../../utils/firebase");
var generateLoanCode = function () {
    return Math.random().toString(36).substring(2, 10).toUpperCase();
};
var createDefaultHomeAddress = function (now) { return ({
    full_address: "",
    homeErf: "",
    date_updated: now,
}); };
var createDefaultEmploymentDetails = function () { return ({
    employment_status: "",
    monthly_income: "",
    employer: "",
    supervisor: "",
    department: "",
    employee_number: "",
    appointment_date: "",
    address: "",
    work_number: {
        country_abbreviation: "NA",
        country_code: "+264",
        phone_number: "",
    },
}); };
var createDefaultFinancialDetail = function () { return ({
    housing: "0",
    transport: "0",
    education: "0",
    electricity: "0",
    groceries_and_other: "0",
    account_payments: [], // Fixed typo: was "acccount_payments"
    fixed_monthly_deductions: [],
    other_obligations: [],
    payment_frequency: "MONTHLY",
    preferred_payday: "",
}); };
var createDefaultPaypointDetails = function (now) { return ({
    paymaster_number: "",
    phone_number: {
        country_abbreviation: "NA",
        country_code: "+264",
        phone_number: "",
    },
    postal_address: "",
    physical_address: "",
    postal_code: "",
    date_updated: now,
}); };
var createDefaultSalaryBankDetails = function (now) { return ({
    account_number: "",
    account_type: "",
    bank: "",
    branch: "",
    date_updated: now,
}); };
var assignIfDefined = function (target, key, value) {
    if (value !== undefined) {
        target[key] = value;
    }
};
var assignBooleanIfDefined = function (target, key, value) {
    if (typeof value === "boolean") {
        target[key] = value;
    }
};
// Create new loan application (Sky Lifestyle compatible structure)
function createLoanApplication(request) {
    return __awaiter(this, void 0, void 0, function () {
        var loansCollectionRef, now, data, newLoanDocRef, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
        return __generator(this, function (_2) {
            switch (_2.label) {
                case 0:
                    _2.trys.push([0, 2, , 3]);
                    loansCollectionRef = (0, firestore_1.collection)(firebase_1.firestore, "loan_applications");
                    now = new Date();
                    data = {
                        amount: typeof (request === null || request === void 0 ? void 0 : request.amount) === "number"
                            ? request.amount
                            : Number((_a = request === null || request === void 0 ? void 0 : request.amount) !== null && _a !== void 0 ? _a : 0),
                        term: (_b = request === null || request === void 0 ? void 0 : request.term) !== null && _b !== void 0 ? _b : loan_application_1.DEFAULT_LOAN_TERM,
                        status: (_c = request === null || request === void 0 ? void 0 : request.status) !== null && _c !== void 0 ? _c : loan_application_1.APPLICATION_STATUS.DRAFT,
                        is_product: (_d = request === null || request === void 0 ? void 0 : request.is_product) !== null && _d !== void 0 ? _d : false,
                        date_started: (_e = request === null || request === void 0 ? void 0 : request.date_started) !== null && _e !== void 0 ? _e : now,
                        code: (_f = request === null || request === void 0 ? void 0 : request.code) !== null && _f !== void 0 ? _f : generateLoanCode(),
                        docs_complete: (_g = request === null || request === void 0 ? void 0 : request.docs_complete) !== null && _g !== void 0 ? _g : false,
                        employment_complete: (_h = request === null || request === void 0 ? void 0 : request.employment_complete) !== null && _h !== void 0 ? _h : false,
                        financial_complete: (_j = request === null || request === void 0 ? void 0 : request.financial_complete) !== null && _j !== void 0 ? _j : false,
                        family_complete: (_k = request === null || request === void 0 ? void 0 : request.family_complete) !== null && _k !== void 0 ? _k : false,
                        friend_complete: (_l = request === null || request === void 0 ? void 0 : request.friend_complete) !== null && _l !== void 0 ? _l : false,
                        paypoint_complete: (_m = request === null || request === void 0 ? void 0 : request.paypoint_complete) !== null && _m !== void 0 ? _m : false,
                        personal_complete: (_o = request === null || request === void 0 ? void 0 : request.personal_complete) !== null && _o !== void 0 ? _o : false,
                        bankDetails_complete: (_p = request === null || request === void 0 ? void 0 : request.bankDetails_complete) !== null && _p !== void 0 ? _p : false,
                        authoriseSalary_complete: (_q = request === null || request === void 0 ? void 0 : request.authoriseSalary_complete) !== null && _q !== void 0 ? _q : false,
                        authoriseBank_complete: (_r = request === null || request === void 0 ? void 0 : request.authoriseBank_complete) !== null && _r !== void 0 ? _r : false,
                        agree_terms: (_s = request === null || request === void 0 ? void 0 : request.agree_terms) !== null && _s !== void 0 ? _s : false,
                        sources: __assign({ initiated: "web", source: "web" }, ((_t = request === null || request === void 0 ? void 0 : request.sources) !== null && _t !== void 0 ? _t : {})),
                        lead_source: __assign({ initiated: lead_source_1.LEAD_SOURCE }, ((_u = request === null || request === void 0 ? void 0 : request.lead_source) !== null && _u !== void 0 ? _u : {})),
                        postal_address: (_v = request === null || request === void 0 ? void 0 : request.postal_address) !== null && _v !== void 0 ? _v : "",
                        // NOTE: user_id_number, gender, isMarried, marriageType are stored in user profile, not loan document
                        home_address: (_w = request === null || request === void 0 ? void 0 : request.home_address) !== null && _w !== void 0 ? _w : createDefaultHomeAddress(now),
                        employment_details: (_x = request === null || request === void 0 ? void 0 : request.employment_details) !== null && _x !== void 0 ? _x : createDefaultEmploymentDetails(),
                        financial_detail: (_y = request === null || request === void 0 ? void 0 : request.financial_detail) !== null && _y !== void 0 ? _y : createDefaultFinancialDetail(),
                        paypoint_details: (_z = request === null || request === void 0 ? void 0 : request.paypoint_details) !== null && _z !== void 0 ? _z : createDefaultPaypointDetails(now),
                        salary_bank_details: (_1 = (_0 = request === null || request === void 0 ? void 0 : request.salary_bank_details) !== null && _0 !== void 0 ? _0 : request === null || request === void 0 ? void 0 : request.salary_bank) !== null && _1 !== void 0 ? _1 : createDefaultSalaryBankDetails(now),
                        date_updated: now,
                    };
                    if (request === null || request === void 0 ? void 0 : request.user)
                        data.user = request.user;
                    if (request === null || request === void 0 ? void 0 : request.branch)
                        data.branch = request.branch;
                    if (request === null || request === void 0 ? void 0 : request.provider)
                        data.provider = request.provider;
                    assignIfDefined(data, "order_number", request === null || request === void 0 ? void 0 : request.order_number);
                    assignIfDefined(data, "order_id", request === null || request === void 0 ? void 0 : request.order_id);
                    assignIfDefined(data, "basket_id", request === null || request === void 0 ? void 0 : request.basket_id);
                    assignIfDefined(data, "force_number", request === null || request === void 0 ? void 0 : request.force_number);
                    // NOTE: user_id_number, gender, marriageType, isMarried are NOT stored in loan documents
                    if (request === null || request === void 0 ? void 0 : request.spouse)
                        data.spouse = request.spouse;
                    if (request === null || request === void 0 ? void 0 : request.family_member)
                        data.family_member = request.family_member;
                    if (request === null || request === void 0 ? void 0 : request.friend)
                        data.friend = request.friend;
                    if ((request === null || request === void 0 ? void 0 : request.latest_payslip) !== undefined)
                        data.latest_payslip = request.latest_payslip;
                    if ((request === null || request === void 0 ? void 0 : request.copy_of_id) !== undefined)
                        data.copy_of_id = request.copy_of_id;
                    if (Array.isArray(request === null || request === void 0 ? void 0 : request.bank_statements))
                        data.bank_statements = request.bank_statements;
                    if (Array.isArray(request === null || request === void 0 ? void 0 : request.products))
                        data.products = request.products;
                    if (request === null || request === void 0 ? void 0 : request.salary_deduction_signature)
                        data.salary_deduction_signature = request.salary_deduction_signature;
                    if (request === null || request === void 0 ? void 0 : request.bank_debit_signature)
                        data.bank_debit_signature = request.bank_debit_signature;
                    if ((request === null || request === void 0 ? void 0 : request.postal_address) !== undefined)
                        data.postal_address = request.postal_address;
                    return [4 /*yield*/, (0, firestore_1.addDoc)(loansCollectionRef, data)];
                case 1:
                    newLoanDocRef = _2.sent();
                    return [2 /*return*/, {
                            success: true,
                            message: "Loan application created successfully",
                            content: {
                                uid: newLoanDocRef.id,
                                status: data.status,
                                date_started: data.date_started.toISOString(),
                            },
                        }];
                case 2:
                    error_1 = _2.sent();
                    console.error("Error creating loan application:", error_1);
                    return [2 /*return*/, {
                            success: false,
                            message: "Failed to create loan application",
                            content: null,
                        }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
// Update existing loan application (Sky Lifestyle structure)
function updateLoanApplication(request) {
    return __awaiter(this, void 0, void 0, function () {
        var loanDocRef, updateData, salaryBankDetails, existingDoc, existing, currentSources, currentLeadSource, error_2;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 4, , 5]);
                    if (!request.uid) {
                        return [2 /*return*/, {
                                success: false,
                                message: "Application UID is required for updates",
                                content: null,
                            }];
                    }
                    loanDocRef = (0, firestore_1.doc)(firebase_1.firestore, "loan_applications", request.uid);
                    updateData = {
                        date_updated: new Date(),
                    };
                    if (typeof request.amount === "number")
                        updateData.amount = request.amount;
                    if (request.term)
                        updateData.term = request.term;
                    if (request.status)
                        updateData.status = request.status;
                    if (request.user)
                        updateData.user = request.user;
                    if (request.branch)
                        updateData.branch = request.branch;
                    if (request.provider)
                        updateData.provider = request.provider;
                    if (typeof request.is_product === "boolean")
                        updateData.is_product = request.is_product;
                    assignBooleanIfDefined(updateData, "personal_complete", request.personal_complete);
                    assignBooleanIfDefined(updateData, "employment_complete", request.employment_complete);
                    assignBooleanIfDefined(updateData, "financial_complete", request.financial_complete);
                    assignBooleanIfDefined(updateData, "family_complete", request.family_complete);
                    assignBooleanIfDefined(updateData, "friend_complete", request.friend_complete);
                    assignBooleanIfDefined(updateData, "paypoint_complete", request.paypoint_complete);
                    assignBooleanIfDefined(updateData, "bankDetails_complete", request.bankDetails_complete);
                    assignBooleanIfDefined(updateData, "docs_complete", request.docs_complete);
                    assignBooleanIfDefined(updateData, "authoriseSalary_complete", request.authoriseSalary_complete);
                    assignBooleanIfDefined(updateData, "authoriseBank_complete", (_a = request.authoriseBank_complete) !== null && _a !== void 0 ? _a : request.authoriseBank_completed);
                    assignBooleanIfDefined(updateData, "agree_terms", request.agree_terms);
                    // NOTE: isMarried, user_id_number, gender, marriageType are NOT stored in loan documents
                    assignIfDefined(updateData, "loan_number", request.loan_number);
                    assignIfDefined(updateData, "order_number", request.order_number);
                    assignIfDefined(updateData, "order_id", request.order_id);
                    assignIfDefined(updateData, "basket_id", request.basket_id);
                    assignIfDefined(updateData, "force_number", request.force_number);
                    // NOTE: user_id_number, gender, marriageType are NOT stored in loan documents
                    assignIfDefined(updateData, "postal_address", request.postal_address);
                    if (request.home_address !== undefined)
                        updateData.home_address = request.home_address;
                    if (request.spouse !== undefined)
                        updateData.spouse = request.spouse;
                    if (request.family_member !== undefined)
                        updateData.family_member = request.family_member;
                    if (request.friend !== undefined)
                        updateData.friend = request.friend;
                    if (request.employment_details !== undefined)
                        updateData.employment_details = request.employment_details;
                    if (request.financial_detail !== undefined)
                        updateData.financial_detail = request.financial_detail;
                    if (request.paypoint_details !== undefined)
                        updateData.paypoint_details = request.paypoint_details;
                    salaryBankDetails = (_b = request.salary_bank_details) !== null && _b !== void 0 ? _b : request.salary_bank;
                    if (salaryBankDetails !== undefined)
                        updateData.salary_bank_details = salaryBankDetails;
                    if (request.salary_deduction_signature !== undefined)
                        updateData.salary_deduction_signature =
                            request.salary_deduction_signature;
                    if (request.bank_debit_signature !== undefined)
                        updateData.bank_debit_signature = request.bank_debit_signature;
                    if (request.date_completed !== undefined)
                        updateData.date_completed = request.date_completed;
                    if (request.latest_payslip !== undefined)
                        updateData.latest_payslip = request.latest_payslip;
                    if (request.copy_of_id !== undefined)
                        updateData.copy_of_id = request.copy_of_id;
                    if (Array.isArray(request.bank_statements))
                        updateData.bank_statements = request.bank_statements;
                    if (Array.isArray(request.products))
                        updateData.products = request.products;
                    if (request.sources)
                        updateData.sources = request.sources;
                    if (!(request.status === "AWAIT" && !updateData.sources)) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, firestore_1.getDoc)(loanDocRef)];
                case 1:
                    existingDoc = _e.sent();
                    existing = existingDoc.exists() ? existingDoc.data() : {};
                    currentSources = (_c = existing === null || existing === void 0 ? void 0 : existing.sources) !== null && _c !== void 0 ? _c : {};
                    currentLeadSource = (_d = existing === null || existing === void 0 ? void 0 : existing.lead_source) !== null && _d !== void 0 ? _d : {};
                    updateData.sources = __assign(__assign({}, currentSources), { updated: "web" });
                    updateData.lead_source = __assign(__assign({}, currentLeadSource), { updated: lead_source_1.LEAD_SOURCE });
                    _e.label = 2;
                case 2: return [4 /*yield*/, (0, firestore_1.updateDoc)(loanDocRef, updateData)];
                case 3:
                    _e.sent();
                    return [2 /*return*/, {
                            success: true,
                            message: "Loan application updated successfully",
                            content: { uid: request.uid, date_updated: new Date().toISOString() },
                        }];
                case 4:
                    error_2 = _e.sent();
                    console.error("Error updating loan application:", error_2);
                    return [2 /*return*/, {
                            success: false,
                            message: "Failed to update loan application",
                            content: null,
                        }];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function getUserDraftLoan(userId, providerId) {
    return __awaiter(this, void 0, void 0, function () {
        var userRef, loansCollectionRef, userLoansQuery, providerRef, querySnapshot, latestDraft_1, latestTimestamp_1, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (!userId) {
                        return [2 /*return*/, {
                                success: false,
                                message: "User ID is required",
                                content: null,
                            }];
                    }
                    userRef = (0, firestore_1.doc)(firebase_1.firestore, "users", userId);
                    loansCollectionRef = (0, firestore_1.collection)(firebase_1.firestore, "loan_applications");
                    userLoansQuery = (0, firestore_1.query)(loansCollectionRef, (0, firestore_1.where)("user", "==", userRef), (0, firestore_1.where)("status", "==", loan_application_1.APPLICATION_STATUS.DRAFT));
                    // If providerId is provided, add provider filter
                    if (providerId) {
                        providerRef = (0, firestore_1.doc)(firebase_1.firestore, "providers", providerId);
                        userLoansQuery = (0, firestore_1.query)(loansCollectionRef, (0, firestore_1.where)("user", "==", userRef), (0, firestore_1.where)("status", "==", loan_application_1.APPLICATION_STATUS.DRAFT), (0, firestore_1.where)("provider", "==", providerRef));
                    }
                    return [4 /*yield*/, (0, firestore_1.getDocs)(userLoansQuery)];
                case 1:
                    querySnapshot = _a.sent();
                    latestDraft_1 = null;
                    latestTimestamp_1 = 0;
                    querySnapshot.forEach(function (loanDoc) {
                        var data = loanDoc.data();
                        // Double-check status (already filtered in query, but being defensive)
                        if (!data || data.status !== loan_application_1.APPLICATION_STATUS.DRAFT) {
                            return;
                        }
                        var started = data.date_started;
                        var timestamp = started && typeof started.toMillis === "function"
                            ? started.toMillis()
                            : started instanceof Date
                                ? started.getTime()
                                : 0;
                        if (!latestDraft_1 || timestamp > latestTimestamp_1) {
                            latestDraft_1 = __assign({ uid: loanDoc.id }, data);
                            latestTimestamp_1 = timestamp;
                        }
                    });
                    return [2 /*return*/, {
                            success: true,
                            message: latestDraft_1 ? "Draft loan found" : "No draft loan found",
                            content: latestDraft_1,
                        }];
                case 2:
                    error_3 = _a.sent();
                    console.error("Error fetching user draft loan:", error_3);
                    return [2 /*return*/, {
                            success: false,
                            message: "Failed to fetch user draft loan",
                            content: null,
                        }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
// Get single loan application by UID
function getLoanApplication(uid) {
    return __awaiter(this, void 0, void 0, function () {
        var loanDocRef, loanDocSnapshot, loanData, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (!uid) {
                        return [2 /*return*/, {
                                success: false,
                                message: "Application UID is required",
                                content: null,
                            }];
                    }
                    loanDocRef = (0, firestore_1.doc)(firebase_1.firestore, "loan_applications", uid);
                    return [4 /*yield*/, (0, firestore_1.getDoc)(loanDocRef)];
                case 1:
                    loanDocSnapshot = _a.sent();
                    if (loanDocSnapshot.exists()) {
                        loanData = loanDocSnapshot.data();
                        return [2 /*return*/, {
                                success: true,
                                message: "Loan application retrieved successfully",
                                content: __assign({ uid: loanDocSnapshot.id }, loanData),
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                success: false,
                                message: "Loan application not found",
                                content: null,
                            }];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    console.error("Error retrieving loan application:", error_4);
                    return [2 /*return*/, {
                            success: false,
                            message: "Failed to retrieve loan application",
                            content: null,
                        }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
// Get all loan applications for a user
function getUserLoanApplications(userId) {
    return __awaiter(this, void 0, void 0, function () {
        var loansCollectionRef, userRef, userLoansQuery, querySnapshot, userLoans_1, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (!userId) {
                        return [2 /*return*/, {
                                success: false,
                                message: "User ID is required",
                                content: [],
                            }];
                    }
                    loansCollectionRef = (0, firestore_1.collection)(firebase_1.firestore, "loan_applications");
                    userRef = (0, firestore_1.doc)(firebase_1.firestore, "users", userId);
                    userLoansQuery = (0, firestore_1.query)(loansCollectionRef, (0, firestore_1.where)("user", "==", userRef));
                    return [4 /*yield*/, (0, firestore_1.getDocs)(userLoansQuery)];
                case 1:
                    querySnapshot = _a.sent();
                    userLoans_1 = [];
                    querySnapshot.forEach(function (doc) {
                        userLoans_1.push(__assign({ uid: doc.id }, doc.data()));
                    });
                    return [2 /*return*/, {
                            success: true,
                            message: "Found ".concat(userLoans_1.length, " loan applications for user"),
                            content: userLoans_1,
                        }];
                case 2:
                    error_5 = _a.sent();
                    console.error("Error retrieving user loan applications:", error_5);
                    return [2 /*return*/, {
                            success: false,
                            message: "Failed to retrieve user loan applications",
                            content: [],
                        }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
// Submit complete loan application (final submission)
function submitLoanApplication(uid) {
    return __awaiter(this, void 0, void 0, function () {
        var now, loanDocRef, existingDoc, existing, currentSources, currentLeadSource, error_6;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    if (!uid) {
                        console.error("❌ No UID provided");
                        return [2 /*return*/, {
                                success: false,
                                message: "Application UID is required",
                                content: null,
                            }];
                    }
                    now = new Date();
                    loanDocRef = (0, firestore_1.doc)(firebase_1.firestore, "loan_applications", uid);
                    return [4 /*yield*/, (0, firestore_1.getDoc)(loanDocRef)];
                case 1:
                    existingDoc = _c.sent();
                    existing = existingDoc.exists() ? existingDoc.data() : {};
                    currentSources = (_a = existing === null || existing === void 0 ? void 0 : existing.sources) !== null && _a !== void 0 ? _a : {};
                    currentLeadSource = (_b = existing === null || existing === void 0 ? void 0 : existing.lead_source) !== null && _b !== void 0 ? _b : {};
                    return [4 /*yield*/, (0, firestore_1.updateDoc)(loanDocRef, {
                            status: loan_application_1.APPLICATION_STATUS.SUBMITTED,
                            date_completed: now,
                            date_updated: now,
                            sources: __assign(__assign({}, currentSources), { updated: "web" }),
                            lead_source: __assign(__assign({}, currentLeadSource), { updated: lead_source_1.LEAD_SOURCE }),
                        })];
                case 2:
                    _c.sent();
                    return [2 /*return*/, {
                            success: true,
                            message: "Loan application submitted successfully",
                            content: {
                                uid: uid,
                                status: loan_application_1.APPLICATION_STATUS.SUBMITTED,
                                date_completed: now.toISOString(),
                            },
                        }];
                case 3:
                    error_6 = _c.sent();
                    console.error("❌ Error submitting loan application:", error_6);
                    return [2 /*return*/, {
                            success: false,
                            message: "Failed to submit loan application",
                            content: null,
                        }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
// Deduplication map: prevents concurrent calls from creating duplicate drafts
var _draftInFlight = new Map();
/**
 * Get or create a draft loan application for the user
 * Enforces "one draft at a time" rule - users can only have one DRAFT loan
 * Uses in-flight deduplication to prevent concurrent calls from creating duplicates
 *
 * @param userId - Firebase user ID
 * @param providerId - Optional provider ID to associate with new draft
 * @param branchId - Optional branch ID to associate with new draft
 * @returns IStandardResponse with draft loan application
 */
function getOrCreateDraftLoan(userId, providerId, branchId) {
    return __awaiter(this, void 0, void 0, function () {
        var dedupeKey, existing, promise;
        return __generator(this, function (_a) {
            dedupeKey = "".concat(userId, ":").concat(providerId !== null && providerId !== void 0 ? providerId : "");
            existing = _draftInFlight.get(dedupeKey);
            if (existing) {
                return [2 /*return*/, existing];
            }
            promise = _getOrCreateDraftLoanImpl(userId, providerId, branchId).then(function (result) {
                _draftInFlight.delete(dedupeKey);
                return result;
            }, function (error) {
                _draftInFlight.delete(dedupeKey);
                throw error;
            });
            _draftInFlight.set(dedupeKey, promise);
            return [2 /*return*/, promise];
        });
    });
}
function _getOrCreateDraftLoanImpl(userId, providerId, branchId) {
    return __awaiter(this, void 0, void 0, function () {
        var draftResponse, userRef, providerRef, branchRef, newDraftRequest, createResponse, error_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, getUserDraftLoan(userId, providerId)];
                case 1:
                    draftResponse = _a.sent();
                    if (!draftResponse.success) {
                        // Draft lookup failed (network error, permissions, etc.)
                        // Do NOT fall through to creation — that would create duplicates
                        return [2 /*return*/, {
                                success: false,
                                message: "Cannot check for existing drafts: ".concat(draftResponse.message),
                                content: null,
                            }];
                    }
                    if (draftResponse.content) {
                        // Draft exists, return it
                        return [2 /*return*/, {
                                success: true,
                                message: "Resuming existing draft application",
                                content: draftResponse.content,
                            }];
                    }
                    userRef = (0, firestore_1.doc)(firebase_1.firestore, "users", userId);
                    providerRef = providerId
                        ? (0, firestore_1.doc)(firebase_1.firestore, "providers", providerId)
                        : undefined;
                    branchRef = branchId
                        ? (0, firestore_1.doc)(firebase_1.firestore, "branches", branchId)
                        : undefined;
                    newDraftRequest = {
                        user: userRef,
                        provider: providerRef,
                        branch: branchRef,
                        status: loan_application_1.APPLICATION_STATUS.DRAFT,
                        amount: 0,
                        term: loan_application_1.DEFAULT_LOAN_TERM,
                        is_product: false,
                        sources: {
                            initiated: "web",
                            source: "web",
                        },
                        lead_source: {
                            initiated: lead_source_1.LEAD_SOURCE,
                        },
                    };
                    return [4 /*yield*/, createLoanApplication(newDraftRequest)];
                case 2:
                    createResponse = _a.sent();
                    if (createResponse.success && createResponse.content) {
                        return [2 /*return*/, {
                                success: true,
                                message: "New draft application created",
                                content: createResponse.content,
                            }];
                    }
                    return [2 /*return*/, {
                            success: false,
                            message: "Failed to create draft application",
                            content: null,
                        }];
                case 3:
                    error_7 = _a.sent();
                    console.error("Error in getOrCreateDraftLoan:", error_7);
                    return [2 /*return*/, {
                            success: false,
                            message: "Error managing draft application",
                            content: null,
                        }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
